module.exports = __webpack_public_path__ + "static/team-logo-1-53fd61743feecce21fdad2cddb6a9345.png";